<template>
  <v-app>
    <v-main>
      <router-view></router-view>

      <v-overlay
        :value="loading"
        opacity="1">
        <v-dialog v-model="loading" persistent width="40%">
          <v-card color="primary" dark>
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
          </v-card>
        </v-dialog>
      </v-overlay>

      <v-overlay
        light
        :value="$store.state.login && !loading"
        opacity="0.8"
      >
        <v-container>
          <v-card color="white">
            <v-card-title class="text-h4 text--primary">
              <b>Please Login first</b>
            </v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-card-subtitle class="text--primary"
                  >Only discord logins for now</v-card-subtitle
                >
                <!-- <v-img v-bind:href="discord_link" src="login_discord.png"></v-img> -->
                <a v-bind:href="discord_link" class="padding">
                  <img src="login_discord.png" style="width: 35vw; min-width: 200px;"/>
                </a>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </v-overlay>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  watch: {
    loading(val) {
      if (!val) return;
      setTimeout(() => (this.loading = false), 3000);
    },
  },

  computed: {
    discord_link: function () {
      return (
        "https://discord.com/api/oauth2/authorize?client_id=910844998205992974&redirect_uri=" + window.location.origin + window.location.pathname + "&response_type=code&scope=identify%20email"
      );
    },
  },

  mounted() {
    setTimeout(() => (this.loading = false), 2000);
  },

  data() {
    return {
      loading: true,
    };
  },
};
</script>

<style></style>